import React, {useRef, useEffect} from 'react';
import styled from 'styled-components';
import TextareaAutosize from '@material-ui/core/TextareaAutosize';

import classes from './TextField.module.css'

const defaultStyle = {
    fontFamily: 'Helvetica Neue, Arial, sans-serif',
    fontSize: '1rem',
    color: 'var(--text-color)'
}

const Container = styled.div`
    display: inline-flex;
    flex-grow: 4;
    min-width: 2rem;
    width: 100%;
`

const Input = styled.input`
    font-family: ${props => props.styles.fontFamily};
    font-size: ${props => props.styles.fontSize};
    background-color: transparent;
    border: none;
    border-radius: 5px;
    color: ${props => props.styles.color};
    width: 100%;
    resize: none;
    overflow: none;
    outline: none;
`

const TextField = props => {
    const {
        type,
        disabled,
        censor,
        value,
        placeholder,
        rowsMin,
        rowsMax,
        unfocus,
        onKeyPress,
        onChange,
        onKeyDown,
        onBlur,
        onFocus,
        focus,
        mantainFocus,
        styles,
        size,
        onSelect,
        addDelay,
        delayDuration,
        submitOnBlur,
        maxLength
    } = props;
    const inputRef = useRef(null);
    const [text, setText] = React.useState(value)
    const updatedStyle = Object.assign({}, defaultStyle, styles)
    const debug = false;
    useEffect(() => {
        setTimeout(() => {
            focus && inputRef.current && inputRef.current.focus()
        }, 500)
    }, [])

    useEffect(() => {
        if(!addDelay){
            return
        }
        const delayDebounceFn = setTimeout(() => {
            if(text !== value){
                debug && console.log('Commit debouce')
                onChange && onChange(text)
            }
        }, delayDuration || 1000)
    
        return () => clearTimeout(delayDebounceFn)
    }, [text])

    const onKeyDownHandler = event => {
        submitOnBlur && [13,27].includes(event.keyCode) && inputRef.current && inputRef.current.blur()
        onKeyDown && onKeyDown(event)
    }

    let element = <TextareaAutosize spellCheck="false" className={classes.TextInput} styles={updatedStyle}
                        value={value} placeholder={placeholder} 
                        rowsMax={rowsMax || 3} rowsMin={rowsMin} 
                        onChange={onChange} onKeyPress={onKeyPress} onKeyDown={onKeyDown} autoFocus={true}
                        onBlur={onBlur}
                        ref={inputRef}/>
    if(type === 'single'){
        element = <Input type={censor ? 'password' : 'text'} styles={updatedStyle} size={size || 20} maxLength={maxLength}
                        ref={inputRef} 
                        // onBlur={!mantainFocus ? null : onBlur ? onBlur : () => inputRef.current && inputRef.current.focus()} 
                        onBlur={onBlur ? onBlur : mantainFocus && inputRef.current && inputRef.current.focus()} 
                        value={addDelay ? text : value} placeholder={placeholder}  
                        autofocus={focus}
                        onChange={addDelay ? (event) => setText(event.target.value) : onChange} 
                        onKeyPress={onKeyPress} 
                        onKeyDown={onKeyDownHandler} 
                        onFocus={onFocus} 
                        disabled={disabled}/>
    }

    return (
        <Container onClick={onSelect}>
            {element}
        </Container>
    )
}

export default TextField